export var LocationType;
(function (LocationType) {
    LocationType["COMMERCIAL"] = "COMMERCIAL";
    LocationType["RESIDENTIAL"] = "RESIDENTIAL";
})(LocationType || (LocationType = {}));
